import React from "react";
import { connect } from "react-redux";
import { ExistingOrders } from "../existingOrders/ExistingOrders";
import { CUSTOMER_DELETED_ORDER_LIST_REQUEST, SAVE_SELECTED_EXISTING_ORDER_REQUEST, PRINT_PDF_REQUEST } from "../../../_utils/constants/Customer";
import { STORE_INFO_REQUEST } from "../../../_utils/constants/admin/StoreInfo";

const DeletedOrders = (props) => {
	return (
		<ExistingOrders
			{...props}
			isDeletedView={true}
			pageTitle="Deleted Orders"
		/>
	);
};

const mapStateToProps = ({ auth, customerInfo, StoreInfo }) => {
	return {
		auth,
		customerInfo: {
			...customerInfo,
			existingOrderList: customerInfo.deletedOrderList,
			totalCount: customerInfo.deletedOrderTotalCount,
			isLoading: customerInfo.isLoading,
			savedExistingOrder: customerInfo.savedExistingOrder,
			printingPdf: customerInfo.printingPdf,
			isPdfProcessing: customerInfo.isPdfProcessing
		},
		StoreInfo
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchExistingOrdersList: (token, sort, page, paginate, listParamState) =>
			dispatch({ type: CUSTOMER_DELETED_ORDER_LIST_REQUEST, token, sort, page, paginate, listParamState }),
		fetchStoreInfo: (token) => dispatch({ type: STORE_INFO_REQUEST, token }),
		saveExistingOrdersList: (token, payload) => dispatch({ type: SAVE_SELECTED_EXISTING_ORDER_REQUEST, token, payload }),
		generatePdf: (token, payload) => dispatch({ type: PRINT_PDF_REQUEST, token, payload }),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(DeletedOrders);
